import axios from 'axios';
import { API_url } from '../api.setup';
import { CustomerCarModel, CustomerCarsArrayModel, GetCustomerCarsArrayModel } from 'src/models/customer/customerCarModel';
import { enqueueSnackbar } from 'notistack';

const API_Controller = '/customersCar';

export const CustomerCarService = {
  getAllData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getCustomerCarsById?customerId=${dataId}`
      );
      return response.data as CustomerCarModel;
    } catch (error) {
      throw error;
    }
  },

  getAllCarsData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getAllCustomerCarsById?customerId=${dataId}`
      );

      return response.data as CustomerCarModel;
    } catch (error) {
      throw error;
    }
  },


  getCarData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?customerCarId=${dataId}`
      );
      return response.data as GetCustomerCarsArrayModel;
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: any) => {
    try {
      const reModel = {
        id: 0,
        customerCarId: dataToAdd.customerCarId,
        registrationNumber: dataToAdd.registrationNumber,
        carNickName: dataToAdd.carNickName,
        fuelTypeId: dataToAdd.fuelTypeId,
        passingYear: dataToAdd.passingYear,
        engineNumber: dataToAdd.engineNumber,
        chassisNumber: dataToAdd.chassisNumber,
        carColor: dataToAdd.carColor,
        isActive: dataToAdd.isActive,
        customerId: dataToAdd.customerId,
        carId: dataToAdd.carId
      };

      const response = await axios.post(`${API_url}${API_Controller}`, reModel);

      enqueueSnackbar(`Cars Added Successfully`, {
        variant: 'success'
      });
    } catch (error) {
      throw error;
    }
  },

  editData: async (dataToUpdate: any) => {
    const reModel = {
      id: dataToUpdate.id,
      customerCarId: dataToUpdate.customerCarId,
      registrationNumber: dataToUpdate.registrationNumber,
      carNickName: dataToUpdate.carNickName,
      fuelTypeId: dataToUpdate.fuelTypeId,
      passingYear: dataToUpdate.passingYear,
      engineNumber: dataToUpdate.engineNumber,
      chassisNumber: dataToUpdate.chassisNumber,
      carColor: dataToUpdate.carColor,
      isActive: dataToUpdate.isActive,
      customerId: dataToUpdate.customerId,
      carId: dataToUpdate.carId
    };

    const response = await axios.put(
      `${API_url}${API_Controller}/update`,
      reModel
    );

    enqueueSnackbar(`Car Edited Successfully`, {
      variant: 'success'
    });
    return response

  },
  deleteData: async (deleteId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`Car Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCarModel[];
    } catch (error) {
      throw error;
    }
  }
};
